import { ThemeType } from '../../themeStyled';

export enum ContentColor {
	WHITE = 'WHITE',
	GRAY = 'GRAY',
	GREY = 'GREY',
	DARK = 'DARK',
	ERIK_RED = 'ERIK_RED',
	ERIK_BLUE = 'ERIK_BLUE',
}

export const contentColorMap: Record<ContentColor, (theme: ThemeType) => string> = {
	[ContentColor.GRAY]: (theme) => theme.colors.gray,
	[ContentColor.GREY]: (theme) => theme.colors.grey,
	[ContentColor.WHITE]: (theme) => theme.colors.white,
	[ContentColor.DARK]: (theme) => theme.colors.dark,
	[ContentColor.ERIK_RED]: (theme) => theme.colors.erik.red,
	[ContentColor.ERIK_BLUE]: (theme) => theme.colors.erik.blue,
};
